module.exports = __webpack_public_path__ + "img/syf.9424a245.jpg";